<template>
  <div class="providers">
    <div id="heading">
      <div class="header-icon fa fa-handshake-o"></div>
      <h1>Our Providers</h1>
    </div>
    <section id="main" class="wrapper">
      <div class="inner">
        <div class="content">
          <div class="text-center">
            <h2>The people who stand with us</h2>
          </div>
          <div class="provider-grid-wrapper">
            <div class="provider-grid">
              <div class="card" v-for="logo in providerLogos" :vid-id="logo" :key="logo">
                <img class="provider-logo" :src="logo" alt=""/>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="content">
          <GetQuoteForm class="get-quote"/>
        </div>
        <hr>
      </div>
    </section>
    <modal v-if="showModal" @close="showModal = false" v-bind:header="modalHeader" v-bind:body="modalBody"/>
  </div>
</template>

<script>
import Vue from 'vue'
import Modal from '@/widgets/Modal'
import GetQuoteForm from '@/components/GetQuoteForm'

import utilities from '../common/utilities.js'
import services from '../common/services/service-directory.js'
import serviceManager from '../common/services/service-manager.js'

Vue.component('modal')

Object.defineProperty(Vue.prototype, '$services', {value: services})
Object.defineProperty(Vue.prototype, '$serviceManager', {value: serviceManager})

export default {
  name: 'Providers',
  data: function () {
    return {
      providerLogos: [],
      showModal: false,
      modalHeader: '',
      modalBody: ''
    }
  },
  mounted: function () {
    this.getLogos()
  },
  methods: {
    getLogos: function () {
      let self = this
      let options = {
        headers: {},
        url: this.$services.logos.url
      }

      this.$serviceManager.get(options).then(function (response) {
        (response.success) ? self.handleLogoSuccess(response) : self.handleLogoFailure(response)
      }).catch(self.handleLogoFailure.bind(self))
    },
    handleLogoSuccess: function (response) {
      for (let i = 0; i < response.data.length; i++) {
        this.providerLogos.push('/img/providers/' + response.data[i])
      }
      this.providerLogos = utilities.shuffleArray(this.providerLogos)
    },
    handleLogoFailure: function () {
      this.modalHeader = 'Error'
      this.modalBody = 'We were unable to complete your request. Please try again later.'

      this.showModal = true
    }
  },
  components: {
    GetQuoteForm,
    Modal
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}

.provider-logo {
  height: 140px;
  padding: 10px;
  max-width: 100%;
  max-height: 100%;
  object-fit: scale-down;
}

.card {
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 5px;
}

.provider-grid-wrapper {
  display: flex;
  justify-content: center;
}

.provider-grid {
  display: grid;
  grid-template-columns: 500px 500px;
  grid-row-gap: 1.5em;
  text-align: center;
  column-gap: 1.5em;
}

@media screen and (max-width: 1280px) {
  .provider-grid {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .provider-logo {
    height: 80px;
    padding: 10px;
  }

  .card {
    margin: 10px 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Providers.vue